import { createAction, props } from '@ngrx/store';
import { Item } from '../models/product-solutions.model';

export const loadSaveProductSolutions = createAction('[SaveProductSolution] Load SaveProductSolutions', props<{ save: Item }>());
